import React from 'react';

import { GetShowroomPrContactsQuery } from 'generated/graphql';

import { useIsShowroomMobileVersion } from 'lib/showroom';

import Button, { ButtonProps } from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';

import { useStyles } from './styles';

export type ComponentProps = {
	contact: GetShowroomPrContactsQuery['getShowroom']['prContacts'][0];
};

const ShowroomPRContact = (props: ComponentProps) => {
	const { contact } = props;
	const classes = useStyles();

	const isMobile = useIsShowroomMobileVersion();

	const commonButtonProps: Partial<ButtonProps> = {
		variant: 'contained',
		color: 'primary',
		classes: {
			root: classes.contactBtnRoot,
			label: classes.contactBtnLabel
		},
		disableElevation: true,
		disableRipple: true
	};

	return (
		<Card id={`showroomPrContact_${contact.id}`} classes={{ root: classes.cardRoot }} elevation={0}>
			<CardContent className={classes.cardContent}>
				<div className={classes.contactData}>
					<Typography component="h5" className={classes.contactName} id={`showroomPrContact_name_${contact.id}`}>
						{contact.name}
					</Typography>
					{contact.jobTitle && (
						<Typography id={`showroomPrContact_jobTitle_${contact.id}`} className={classes.jobTitle}>
							{contact.jobTitle}
						</Typography>
					)}
					{contact.email && !isMobile && (
						<Typography id={`showroomPrContact_email_${contact.id}`} className={classes.email}>
							{contact.email}
						</Typography>
					)}
					{contact.phone && !isMobile && (
						<Typography id={`showroomPrContact_phone_${contact.id}`} className={classes.phone}>
							{contact.phone}
						</Typography>
					)}
				</div>
				{(contact.email || contact.phone) && (
					<div className={classes.contactButtons}>
						{contact.email && (
							<Button {...commonButtonProps} href={`mailto:${contact.email}`} id={`showroomPrContactButton_email_${contact.id}`}>
								<EmailIcon fontSize="small" />
							</Button>
						)}
						{contact.phone && (
							<Button
								{...commonButtonProps}
								href={`tel:${contact.phone.replace(/ /g, '')}`}
								id={`showroomPrContactButton_phone_${contact.id}`}
							>
								<PhoneIcon fontSize="small" />
							</Button>
						)}
					</div>
				)}
			</CardContent>
		</Card>
	);
};

export default React.memo(ShowroomPRContact);
